import urls from "../urls";

export function holidayTypeUrl(name) {
  return urls.holidayTypes+"/"+name;
}
